import { FC } from 'react';
import { StyledButtons } from '../../styled';
import { PrimaryButton } from './primary-button';
import { SecondaryButton } from './secondary-button';

export interface ButtonsProps {
  primaryButtonText: string;
  primaryButtonHref?: string;
  secondaryButtonText?: string;
  secondaryButtonHref?: string;
  isSecondaryButtonVisible?: boolean;
  onClose: () => void;
}

export const Buttons: FC<ButtonsProps> = ({
  primaryButtonText,
  primaryButtonHref,
  secondaryButtonText,
  secondaryButtonHref,
  isSecondaryButtonVisible = false,
  onClose,
}) => (
  <StyledButtons>
    <PrimaryButton
      text={primaryButtonText}
      href={primaryButtonHref}
      onClose={onClose}
    />
    {isSecondaryButtonVisible &&
      secondaryButtonHref &&
      secondaryButtonHref !== '' && (
        <SecondaryButton
          text={secondaryButtonText}
          href={secondaryButtonHref}
          onClick={onClose}
        />
      )}
  </StyledButtons>
);
